module.exports = {
  PORT: "4022",
  NODE_ENV: "production",

  SERVER_DEV_URL: "http://localhost:3131",
  SERVER_STAGING_URL: "https://ihs-api.cloudxier.dev",
  SERVER_PROD_URL: "https://api.isaacademy.co.id",

  TICKET_SERVER_DEV_URL: "http://localhost:3123",
  TICKET_SERVER_STAGING_URL: "https://ihs-webinar-api.cloudxier.dev",
  TICKET_SERVER_PROD_URL: "https://webinar-api.isaacademy.co.id",

  CLIENT_DEV_HOST: "localhost",
  CLIENT_STAGING_HOST: "ihs.cloudxier.dev",
  CLIENT_PROD_HOST: "isaacademy.co.id",

  CLIENT_DEV_URL: "http://localhost:3000",
  CLIENT_STAGING_URL: "https://ihs.cloudxier.dev",
  CLIENT_PROD_URL: "https://www.isaacademy.co.id",

  MAIN_WEBSITE_TITLE: "IHS | ",
  SITE_NAME: "Inhocsigno Hominum Salvator",
};
